import { buildAddressFormSchema } from '../address/create-form.js';
import { VendorAddressType } from './rules.js';
export const vendorAddressFormSchema = buildAddressFormSchema(VendorAddressType);
//# sourceMappingURL=create-form.js.map